/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ReactHtmlParser from 'react-html-parser';

import {
    object, string, func,
} from 'prop-types';
import { useMediaQuery } from '@material-ui/core';
import { useSelector } from 'react-redux';
import InlineErrorMessage from '../../../../pages/Checkout/containers/CheckoutFloral/Partials/ErrorMessage/InlineErrorMessage';
import noop from '../../../../helpers/noop';
import PriceBreakDownUi from '../../GraphqlCategoryPage/Partials/GraphqlProductContainer/Partials/GraphqlSimpleProduct/DesktopSimpleProduct/PriceBreakDownUi';
import { getCaCampaign } from '../../../../../state/ducks/App/App-Selectors';
import CaPriceVariant from '../../GraphqlCategoryPage/Partials/GraphqlProductContainer/Partials/GraphqlSimpleProduct/DesktopSimpleProduct/CaPriceTestType';

const useStyle = makeStyles((theme) => ({
    orderItemContainer: {
        width: '100%',
        display: 'grid',
        gridTemplateColumns: '74px calc(100% - 74px)',
    },
    itemDetails: {
        fontSize: '16px',
        lineHeight: '21px',
        letterSpacing: '0.18px',
        margin: '0px 0px 0px 16px',
        color: '#777777',
        display: 'grid',
        gridTemplateColumns: 'auto',
        width: '70%',
        textWrap: 'balance',
        '& span': {
            fontWeight: '400',
            color: '#000000',
        },
        [theme?.breakpoints?.down('600')]: {
            width: '100%',
            marginLeft: '12px',
        },
    },
    imgContainer: {
        width: '100%',
        gridColumn: '1',
        gridRow: '1/span 2',
    },
    productContainer: {
        marginLeft: '16px',
        [theme?.breakpoints?.down('600')]: {
            marginLeft: '12px',
        },
    },
    itemSku: {
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0.5px',
        color: '#000000',
    },
    productNameContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    imgProduct: {
        width: '100%',
    },
    itemProdName: {
        fontSize: '18px',
        lineHeight: '26px',
        letterSpacing: '0.24px',
        margin: '0px',
        padding: '0px',
        fontWeight: '700',
        fontFamily: 'Area Variable, Lato',
        width: '70%',
        [theme?.breakpoints?.down('600')]: {
            fontSize: '18px',
            width: '100%',
            lineHeight: '26px',
        },
    },
    itemZipCode: {
        color: '#777777',
        '& span': {
            color: '#000000',
        },
    },
    itemInfo: {
        display: 'grid',
        gridTemplateColumns: '50px auto',
        marginBottom: '4px',
        fontSize: '16px',
        lineHeight: '24px',
        marginTop: '8px',
        [theme?.breakpoints?.down('600')]: {
            gridTemplateColumns: '47px auto',
            marginTop: '4px',
        },
        [theme?.breakpoints?.down('382')]: {
            gridTemplateColumns: '43px auto',
        },
    },
    nameContainer: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: '8px',
        [theme?.breakpoints?.down('600')]: {
            marginTop: '4px',
        },
    },
    label: {
        color: '#777777 !important',
    },
    btnDateDelivery: {
        textDecorationLine: 'underline',
        textUnderlineOffset: '3px',
        cursor: 'pointer',
        lineHeight: '21px',
    },
    inlineErrorMessage: {
        paddingLeft: '10px',
    },
    flexMessage: {
        fontSize: '14px',
        lineHeight: '19px',
        display: 'flex',
        letterSpacing: '0.16px',
        color: '#000',
        marginTop: '4px',
        [theme?.breakpoints?.down('600')]: {
            fontSize: '12px',
            lineHeight: '17px',
        },
    },
    titleProd: {
        fontSize: '18px',
        lineHeight: '23px',
        color: '#21571D',
        textAlign: 'center',
        width: '30%',
        '& strong': {
            display: 'flex',
            alignItems: 'center',
        },
    },
    iconCheck: {
        display: 'flex',
        marginLeft: '8px',
    },
    priceContainer: {
        display: 'flex',
        fontSize: '16px',
        lineHeight: '21px',
        [theme?.breakpoints?.down('600')]: {
            lineHeight: '24px',
        },
    },
    priceLabel: {
        marginRight: '13px',
        color: '#777777 !important',
        float: 'left',
        [theme?.breakpoints?.down('600')]: {
            marginRight: '10px',
        },
    },
    price: {
        float: 'left',
        display: 'inline-block',
        width: '100%',
    },
    salePrice: {
        color: '#a1001a !important',
        marginLeft: '5px',
    },
    productPrice: {
        marginRight: '5px',
        float: 'left',
    },
}));

const AddonProductUI = ({
    itemZipCode, productDetails, product, imgSrc, openModalDeliverydate,
    serverSideOrderItemError, cartOrderDeliveryDate, flexMessage,
}) => {
    const classes = useStyle();
    const isMobile = useMediaQuery('(max-width: 600px)');
    const caCampaign = useSelector(getCaCampaign);
    const isCaDelivery = CaPriceVariant(caCampaign);
    const formatDate = (dateString) => {
        if (dateString) {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0'); // Add leading zero if needed
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
            const year = String(date.getFullYear()).slice(-2); // Get last two digits of the year
            return `${month}/${day}/${year}`;
        }
        return false;
    };

    const isInternationalProduct = (itemDetails) => ['USA', 'US', 'CAN', 'CA'].includes(itemDetails?.deliveryInfo?.countryCode || '');

    const deliveryTo = (itemDetails) => {
        let deliveryToText = (
            <div className={classes.itemInfo}>
                <span className={classes.label}>ZIP</span><span>{itemDetails?.deliveryInfo?.zipCode || 'NA'}</span>
            </div>
        );
        const internationalProduct = isInternationalProduct(itemDetails);

        if (internationalProduct) {
            deliveryToText = <div className={classes.itemInfo}><span className={classes.label}>ZIP</span><span>{itemDetails?.deliveryInfo?.zipCode || 'NA'} - International</span></div>;
        }

        return deliveryToText;
    };

    const generateTotal = (charges, itemPrice) => {
        const chargesOnly = [];
        (charges || []).forEach((data) => {
            if (!Number.isNaN(data.amount)) {
                chargesOnly.push(parseFloat(data.amount));
            }
        });
        const total = chargesOnly.reduce((sum, num) => sum + num, 0) + parseFloat(itemPrice);
        return total;
    };
    const addToCheck = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M20.7071 5.29289C21.0976 5.68342 21.0976 6.31658 20.7071 6.70711L9.70711 17.7071C9.51957 17.8946 9.26522 18 9 18C8.73478 18 8.48043 17.8946 8.29289 17.7071L3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929C3.68342 10.9024 4.31658 10.9024 4.70711 11.2929L9 15.5858L19.2929 5.29289C19.6834 4.90237 20.3166 4.90237 20.7071 5.29289Z" fill="#21571D" />
        </svg>
    );
    const listPrice = generateTotal(productDetails?.itemInfo?.charges, productDetails.product?.listPrice);
    const salePrice =  generateTotal(productDetails?.itemInfo?.charges, productDetails.product?.salePrice);
    const itemInfoPrice = generateTotal(productDetails?.itemInfo?.charges, productDetails.itemInfo?.price);
    return (
        <div id="orderItem" className={classes.orderItemContainer}>
            <div  id="itemImage" className={classes.imgContainer}>
                <img
                    className={classes.imgProduct}
                    src={`${imgSrc}?quality=100`}
                    alt="product"
                />
            </div>
            <div
                item
                id="product-added"
                data-test="product-details"
                name="productDetails"
                className={classes.productContainer}
            >
                <div className={classes.productNameContainer}>
                    <div className={classes.itemProdName}>{ReactHtmlParser(product?.parentProductName)}</div>
                    {!isMobile && <div className={classes.titleProd}><strong>Added to Cart<span className={classes.iconCheck}>{addToCheck()}</span></strong></div>}
                </div>
                {serverSideOrderItemError && <div className={classes.inlineErrorMessage}> <InlineErrorMessage error={serverSideOrderItemError} /> </div>}
            </div>
            <div className={classes.itemDetails}>
                <div className={classes.container}>
                    <div className={classes.nameContainer}>
                        <div className={classes.priceContainer}>
                            <span className={classes.priceLabel}>Price</span>
                            <span className={classes.price}>
                                {listPrice === salePrice ? (
                                // Show only the list price if they are the same
                                    <span>{`$${parseFloat(itemInfoPrice).toFixed(2)}`}</span>
                                ) : (
                                // Show both list price and sale price if they differ
                                    <div>
                                        <s className={classes.strikePrice}>
                                            {`$${parseFloat(listPrice).toFixed(2)}`}
                                        </s>
                                        <span className={classes.salePrice}>
                                            {`$${parseFloat(salePrice).toFixed(2)}`}
                                        </span>
                                    </div>
                                )}
                                <PriceBreakDownUi
                                    dynamicPriceData={{
                                        ...productDetails?.itemInfo || {},
                                        prices: [
                                            {
                                                displayCharges: productDetails?.itemInfo?.displayCharges,
                                                value: parseFloat(productDetails?.itemInfo?.price).toFixed(2),
                                                type: 'sale',
                                                charges: productDetails?.itemInfo?.charges || [],
                                                total: generateTotal(productDetails?.itemInfo?.charges, productDetails?.itemInfo?.price),
                                            },
                                            {
                                                displayCharges: productDetails?.itemInfo?.displayCharges,
                                                value: parseFloat(productDetails?.itemInfo?.price).toFixed(2),
                                                type: 'retail',
                                                charges: productDetails?.itemInfo?.charges || [],
                                                total: generateTotal(productDetails?.itemInfo?.charges, productDetails?.itemInfo?.price),
                                            },
                                        ],
                                        brand: productDetails?.product?.brandCode,
                                        productType: productDetails?.product?.productType,
                                    }}
                                    addOnPrice
                                    isCaDelivery={isCaDelivery}
                                />
                            </span>

                        </div>
                    </div>
                    <div className={classes.dateContainer}>
                        {cartOrderDeliveryDate ? (
                            <div className={classes.itemInfo}>
                                <span className={classes.label}>Date</span>
                                <span>
                                    <span
                                        role="presentation"
                                        className={classes.btnDateDelivery}
                                        aria-label={cartOrderDeliveryDate}
                                        onClick={() => openModalDeliverydate(productDetails.cartItemId, product?.productCode, product?.productType, product?.brandCode, itemZipCode)}
                                    >
                                        {(flexMessage?.toLowerCase?.().includes?.('between') ? 'Flexible Dates Selected*' : formatDate(cartOrderDeliveryDate)) || 'Select a delivery date'}
                                    </span>
                                    {flexMessage && <div className={classes.flexMessage}>{flexMessage?.toLowerCase?.().includes?.('between') ? `*${flexMessage}` : flexMessage}</div>}
                                </span>
                            </div>
                        ) : ''}
                    </div>
                </div>

            </div>
        </div>

    );
};

AddonProductUI.propTypes = {
    productDetails: object,
    serverSideOrderItemError: string,
    product: object,
    flexMessage: string,
    openModalDeliverydate: func,
    cartOrderDeliveryDate: string,
    itemZipCode: string.isRequired,
    imgSrc: string,
};

AddonProductUI.defaultProps = {
    serverSideOrderItemError: '',
    productDetails: {
        product: {},
    },
    flexMessage: '',
    cartOrderDeliveryDate: '',
    product: {},
    openModalDeliverydate: noop,
    imgSrc: '',
};

export default AddonProductUI;
